(function () {
  const root = document.querySelector('.storytrust-faq');
  if (!root || root.dataset.mtFaqEnhanced === 'text-reveal-sections') return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const text = (node) => (node && (node.innerText || node.textContent) ? (node.innerText || node.textContent).trim().replace(/\s+/g, ' ') : '');

  root.dataset.mtFaqEnhanced = 'text-reveal-sections';
  root.classList.add('mt-faq-text-reveal');
  document.documentElement.classList.add('mt-faq-text-reveal-document');
  document.body.classList.add('mt-faq-text-reveal-page');

  const indexNav = root.querySelector(':scope > .story-section--index');
  const sections = Array.from(root.querySelectorAll(':scope > section.story-section')).filter((section) => section !== indexNav);

  if (indexNav) {
    indexNav.hidden = true;
    indexNav.setAttribute('aria-hidden', 'true');
  }

  const stage = document.createElement('div');
  stage.className = 'mt-reveal-stage';
  const firstSection = sections[0];
  if (firstSection) root.insertBefore(stage, firstSection);
  else root.appendChild(stage);

  const pageProgress = document.createElement('div');
  pageProgress.className = 'mt-page-scroll-progress';
  pageProgress.setAttribute('aria-hidden', 'true');

  const pageProgressFill = document.createElement('div');
  pageProgressFill.className = 'mt-page-scroll-progress__fill';
  pageProgress.appendChild(pageProgressFill);
  document.body.appendChild(pageProgress);

  function splitTextNodes(rootNode, words) {
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const parts = node.nodeValue.split(/(\s+)/);
      const fragment = document.createDocumentFragment();
      parts.forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        const span = document.createElement('span');
        span.className = 'mt-reveal-word';
        span.dataset.wordIndex = String(words.length);
        span.textContent = part;
        words.push(span);
        fragment.appendChild(span);
      });
      node.replaceWith(fragment);
    });
  }

  const sectionModels = sections.map((section, index) => {
    const heading = section.querySelector(':scope > h2');
    const originalNodes = Array.from(section.childNodes);
    const panel = document.createElement('article');
    panel.className = 'mt-reveal-panel';
    panel.setAttribute('aria-labelledby', heading && section.id ? `${section.id}-heading` : '');

    const copy = document.createElement('div');
    copy.className = 'mt-reveal-copy';

    if (heading) {
      heading.id = heading.id || `${section.id || `faq-${index + 1}`}-heading`;
      heading.classList.add('mt-reveal-question');
      panel.appendChild(heading);
    }

    originalNodes.forEach((child) => {
      if (child !== heading) copy.appendChild(child);
    });
    panel.appendChild(copy);

    section.classList.add('mt-reveal-section');
    section.dataset.mtRevealIndex = String(index);
    section.dataset.mtRevealTitle = text(heading);
    section.appendChild(panel);
    stage.appendChild(section);

    const words = [];
    splitTextNodes(copy, words);
    section.style.setProperty('--mt-word-count', String(words.length));
    section.style.setProperty('--mt-section-duration', `${Math.max(132, Math.min(210, 118 + words.length * 0.52))}dvh`);

    if (reduceMotion) {
      words.forEach((word) => word.classList.add('is-visible'));
      section.classList.add('is-visible');
    }

    return { section, panel, words, visibleWords: reduceMotion ? words.length : -1 };
  });

  let ticking = false;
  let activeModel = null;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function setVisibleWords(model, count) {
    if (model.visibleWords === count) return;
    model.visibleWords = count;
    model.words.forEach((word, index) => {
      word.classList.toggle('is-visible', index < count);
    });
  }

  function updatePageProgress() {
    const doc = document.documentElement;
    const maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
    const progress = clamp((window.scrollY || doc.scrollTop || 0) / maxScroll, 0, 1);
    pageProgress.style.setProperty('--mt-page-progress', progress.toFixed(4));
  }

  function update() {
    ticking = false;
    updatePageProgress();
    if (reduceMotion) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const focusLine = viewportHeight * (window.matchMedia('(max-width: 760px)').matches ? 0.62 : 0.48);
    let nextActive = null;
    let bestDistance = Infinity;
    let bestContainsFocus = false;

    sectionModels.forEach((model) => {
      const rect = model.section.getBoundingClientRect();
      const visible = rect.bottom > viewportHeight * 0.12 && rect.top < viewportHeight * 0.86;
      model.section.classList.toggle('is-visible', visible);

      const containsFocus = rect.top <= focusLine && rect.bottom >= focusLine;
      const distance = containsFocus ? Math.abs(rect.top - focusLine) : Math.abs((rect.top + rect.height * 0.5) - focusLine);
      if (visible && ((containsFocus && !bestContainsFocus) || (containsFocus === bestContainsFocus && distance < bestDistance))) {
        bestContainsFocus = containsFocus;
        bestDistance = distance;
        nextActive = model;
      }
    });

    if (nextActive && nextActive !== activeModel) {
      activeModel = nextActive;
      sectionModels.forEach((model) => {
        model.section.classList.toggle('is-active', model === activeModel);
      });
    }

    if (!activeModel) return;

    const rect = activeModel.section.getBoundingClientRect();
    const travel = Math.max(1, rect.height - viewportHeight);
    const progress = clamp((-rect.top + viewportHeight * 0.1) / (travel * 0.82), 0, 1);
    const count = Math.round(progress * (activeModel.words.length + 8));
    setVisibleWords(activeModel, clamp(count, 0, activeModel.words.length));
    activeModel.section.style.setProperty('--mt-reveal-progress', progress.toFixed(4));

    sectionModels.forEach((model) => {
      if (model === activeModel) return;
      const rect = model.section.getBoundingClientRect();
      if (rect.bottom < 0) setVisibleWords(model, model.words.length);
      if (rect.top > viewportHeight) setVisibleWords(model, 0);
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();

  if (location.hash) {
    const target = sectionModels.find((model) => model.section.id === decodeURIComponent(location.hash.slice(1)));
    if (target) window.setTimeout(() => target.section.scrollIntoView({ behavior: 'auto', block: 'start' }), 60);
  }
})();
